import { useContext } from 'react'
import { ResourceContext } from 'App'

export const useAuth = () => {
  return useContext(ResourceContext)
}
